// extracted by mini-css-extract-plugin
export var fadeInAnimation = "MobileNavItem-module--fadeInAnimation--e8504";
export var item = "MobileNavItem-module--item--7f1f5";